import React from 'react';
import { CORE_NAVIGATION_COMPONENT_CONFIG } from '../../core/config/navigation/navigation.config';
import { APP_NAVIGATION_COMPONENT_CONFIG } from '../../app/config/navigation/navigation.config';

export const navigationComponentConfig = {
  components: (
    <>
      {CORE_NAVIGATION_COMPONENT_CONFIG.component}
      {APP_NAVIGATION_COMPONENT_CONFIG.component}
    </>
  ),
};
